export enum PaymentRoute {
    PAYMENTS = "show-payments",
    PAYMENTS_INDEX = "show-payments",
    ADD_NEW_CARD = "add-new-card",
    VPA_TIMER = "vpa-timer",
    PAYMENT_TXN_STATUS_POLLING = "payment-txn-status-polling",
    CONFIRM_ORDER = "confirm-order",
    DIRECT_PLACE_ORDER = "direct-place-order",
    MORE_BANKS = "more-banks",
    VERIFY_WALLET_LINK_OTP = "verify-wallet-link-otp",
    LINK_WALLET_WITH_NUMBER = "link-wallet-with-number",
    VERIFY_VPA = "verify-vpa",
    LINK_PAYLATER = "link-paylater",
    LINK_PAYLATER_MOBILE = "link-paylater-mobile",
    REDIRECT_PAGE = "redirect-page",
    MORE_PAYMENT_GROUPS = "more-payment-groups",
    MORE_PAYMENT_METHODS = "more-payment-methods",
    ADD_SWIGGY_MONEY = "add-swiggy-money",
    SWIGGY_MONEY_PAYMENTS = "swiggy-money-payments",
    ADD_SWIGGY_MONEY_INDEX = "add-swiggy-money",
}

export const MISSING_ROUTE_DATA = "Missing route data";
